// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__26dp5","errors":"Errors_errors__2u2Tg"};